import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import ShareFile from "./pages/ShareFile";
import { Endpoints } from "./services/endpoints";
import axios from "axios";

function App() {
  const checkHealth = async () => {
    try {
      const res = await axios.get(Endpoints.healthCheck);
      const { data } = res;
      console.log(data);
    } catch (err) {
      console.error(err);
    }
  };
  React.useEffect(() => {
    checkHealth();
  }, []);

  return (
    <main>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sharefile/:id" element={<ShareFile />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </main>
  );
}

export default App;
